import $ from 'jquery';
import Framework from 'framework';
import _ from 'ext:lodash';
import selectorConfig from '../config.js';
import constants from 'lib/constants';
import moment from 'moment';

var toolTip = selectorConfig.ltbucksToolTip;
var toolTipInfo = selectorConfig.ltbucksToolTipInfo;
var toolTipLink = selectorConfig.ltbucksToolTipLink;

let template = `
<div class="gauge-icon ltbucksToolTip">
	<a href="#" role="button" class="ltbucksToolTipLink" data-toggle="tooltip" data-trigger="click" data-prevent-default="true" data-placement="bottom" aria-describedby="ltbucksInfo">
		<span class="ico-info-solid"></span>
	</a>
	<div class="sr-only ltbucksToolTipInfo">
	</div>
</div>
	`;

export default class LtBucksExpiration {
	constructor(ProfileStore) {
		this.ProfileStore = ProfileStore;
	}

	sortExpirations(dirtyData) {
		var cleanedData = [].concat(dirtyData);

		cleanedData = _.orderBy(cleanedData, (expiration) => {
			return moment(expiration.expirationDate, moment.ISO_8601).toDate();
		}, ['asc']);

		return cleanedData;
	}

	renderExpirations() {
		var output = '';
		var profile = this.ProfileStore;
		if(profile && profile.memberDetails && profile.memberDetails.ltBucksDetails && profile.memberDetails.ltBucksDetails.length > 0) {
			let sortedDetails = this.sortExpirations(profile.memberDetails.ltBucksDetails);
			let expirations = sortedDetails.map((expiration)=> {
				var expirationString = '';
				var expLocalDate = moment(expiration.expirationDate, moment.ISO_8601);
				if(expLocalDate.isAfter(moment())) {
					var expFormattedDate = expLocalDate.format('L');
					expirationString = `<p class='micro m-b-1'><strong>${expiration.amount} LT BUCK$</strong><br>Expire on ${expFormattedDate}</p>`;
				}
				return expirationString;
			}).join('');

			output += `<div class='text-xs-center'>${expirations}<p class='m-b-0'><a href='${Framework.global.lt.globalPageDrivers.global.ltbucks}'>Redeem</a></p></div>`;
		}
		return output;
	}

	updateLtBucksExpiration() {
		var profile = this.ProfileStore;
		//show hide items if the user has a profile
		if(profile.memberDetails && profile.memberDetails.ltBucksDetails && profile.memberDetails.ltBucksDetails.length && profile.memberDetails.ltBucksDetails.length > 0 && profile.memberDetails.ltBucksBalance > 0){
			var html = this.cachedTemplate || this.getTemplate();
			var expirations = this.renderExpirations();

			// update the link with the expirations
			html.find(toolTipLink).attr('data-original-title', expirations);

			// update the sr-only with the expirations
			html.find(toolTipInfo).html(expirations);

			// update the dial with the tooltip
			$(toolTip).replaceWith(html);

			$(toolTipLink).tooltip({
				html: true,
				constraints: [{to: $('body')[0], attachment: 'together', pin: true }]
			});
		}
	}

	getTemplate() {
		this.cachedTemplate = $(template);
		return this.cachedTemplate;
	}
}
